import apiClient from "./apiClient";
import { CallMetrics } from "home/models";


const getDialerMetrics = async (): Promise<CallMetrics> => {
    return apiClient.get(`/dashboard/dialer-metrics`, {});
  };
  
  const getExceptions = async (): Promise<any> => {
    return apiClient.get(`/dashboard/bnsf-exceptions`, {});
  };

  const getRequests = async (): Promise<any> => {
    return apiClient.get(`/dashboard/bnsf-requests`, {});
  };

  const getUpMessageMetrics = async (): Promise<any> => {
    return apiClient.get(`/dashboard/up-message-metrics`, {});
  };

  const getCsxMessageMetrics = async (): Promise<any> => {
    return apiClient.get(`/dashboard/csx-message-metrics`, {});
  };

  const dashboardService = {
    getDialerMetrics,
    getExceptions,
    getRequests,
    getCsxMessageMetrics,
    getUpMessageMetrics
  };
  
  export default dashboardService;